var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appbar"},[_c('logo',{staticClass:"logo cursor-pointer",on:{"click":function($event){return _vm.goTo({name: 'Landing'})}}}),_c('b-icon',{staticClass:"cursor-pointer gilroy-m",attrs:{"icon":"list","font-scale":"1.5"},on:{"click":_vm.toggleSidebar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }